import { faBell } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Col, Row } from "react-bootstrap";
import { ILicenceActionDetails } from "../../../api/ILicensingAction";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";

interface LicenceActionDetailsProps {
  licenceActionDetails: ILicenceActionDetails;
}

const LicenceActionDetails = ({
  licenceActionDetails,
}: LicenceActionDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField label={"Action Name"} value={licenceActionDetails.name} />
          <EpaField
            label={"Description"}
            value={licenceActionDetails.description}
          />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Issued Date"}
            value={licenceActionDetails.issueddate}
          />
          <EpaField label={"Due Date"} value={licenceActionDetails.duedate} />
          <EpaField
            label={"Replied On Date"}
            value={licenceActionDetails.repliedondate}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Licensing Action Details"} content={bodyElements} />;
};

export default LicenceActionDetails;
